import { ASSETS } from '@/constants/assets';

const SERVICES = [
  'Recuperação de Cilindros',
  'Recuperação de Bombas',
  'Recuperação de Motores',
  'Recuperação de Válvulas',
  'Recuperação de Redutores',
  'Componentes Novos',
];

const EQUIPMENT_TYPES = [
  'Escavadeiras',
  'Retroescavadeiras',
  'Pás Carregadeiras',
  'Motoniveladoras',
  'Empilhadeiras',
  'Plataformas Elevatórias',
  'Guindastes e Muncks',
  'Máquinas Florestais',
  'Máquinas Agrícolas',
];

const COVERAGE = [
  'Grande Vitória',
  'Espírito Santo',
  'Sul da Bahia',
  'Leste de Minas Gerais',
  'Norte do Rio de Janeiro',
];

export default function Footer() {
  return (
    <footer id="contato" className="bg-secondary-900 text-background-50/80">
      {/* Main Footer Grid */}
      <div className="max-w-container mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-10">

          {/* Coluna 1 — Empresa */}
          <div className="flex flex-col">
            {/* Faixa branca — DURAFLOW */}
            <div className="bg-background-50 rounded-lg px-5 py-5 flex items-center justify-center w-full mb-5">
              <img
                src={ASSETS.logos.duraflowHeader}
                alt="DURAFLOW Soluções Hidráulicas"
                className="w-[70%] max-h-[50px] md:max-h-[58px] h-auto"
              />
            </div>

            <p className="text-xs text-background-50/55 leading-relaxed mb-4">
              Especialistas em soluções hidráulicas para máquinas pesadas, equipamentos móveis e aplicações industriais.
            </p>

            <div className="flex flex-col gap-2 mb-4">
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-background-50/60 bg-background-50/8 px-2.5 py-1 rounded-md self-start">
                <i className="ri-verified-badge-line text-sm w-4 h-4 flex items-center justify-center"></i>
                ISO 9001:2015
              </span>
              <span className="text-xs text-background-50/40 flex items-center gap-1.5 self-start">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                Desde 2007
              </span>
            </div>

            {/* Faixa branca — Grupo Pilar */}
            <div className="mt-auto pt-3 border-t border-background-50/8">
              <div className="bg-background-50 rounded-lg px-4 py-3 flex items-center justify-center w-full mb-2">
                <img
                  src={ASSETS.logos.grupoPilar}
                  alt="Grupo Pilar"
                  className="w-[75%] max-h-[48px] md:max-h-[56px] h-auto"
                />
              </div>
              <span className="text-xs text-background-50/35 block text-center">
                Empresa do Grupo Pilar
              </span>
            </div>
          </div>

          {/* Coluna 2 — Serviços */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Serviços
            </h4>
            <ul className="space-y-2">
              {SERVICES.map((item) => (
                <li key={item}>
                  <a
                    href="#servicos"
                    className="text-xs text-background-50/55 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 3 — Equipamentos */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Equipamentos
            </h4>
            <ul className="space-y-2">
              {EQUIPMENT_TYPES.map((item) => (
                <li key={item}>
                  <a
                    href="#equipamentos"
                    className="text-xs text-background-50/55 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 4 — Área de Atuação */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Área de Atuação
            </h4>
            <ul className="space-y-2">
              {COVERAGE.map((region) => (
                <li key={region} className="flex items-center gap-2 text-xs text-background-50/55">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0 text-primary-400/70">
                    <i className="ri-map-pin-line text-sm"></i>
                  </span>
                  {region}
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 5 — Contato */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Contato
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={ASSETS.social.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-xs text-background-50/55 hover:text-primary-400 transition-colors duration-200 cursor-pointer group"
                >
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-200">
                    <i className="ri-whatsapp-line text-sm text-primary-400"></i>
                  </span>
                  <span>
                    <span className="block text-background-50/70 font-medium">WhatsApp</span>
                    <span className="text-background-50/50">{ASSETS.contact.phone}</span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${ASSETS.contact.email}`}
                  className="flex items-center gap-2 text-xs text-background-50/55 hover:text-primary-400 transition-colors duration-200 cursor-pointer group"
                >
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-200">
                    <i className="ri-mail-line text-sm text-primary-400"></i>
                  </span>
                  <span>
                    <span className="block text-background-50/70 font-medium">E-mail</span>
                    <span className="text-background-50/50">{ASSETS.contact.email}</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-background-50/6">
        <div className="max-w-container mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/25 text-center sm:text-left">
            &copy; {new Date().getFullYear()} DURAFLOW Soluções Hidráulicas. Todos os direitos reservados.
          </p>
          <p className="text-xs text-background-50/20">
            Engenharia especializada em sistemas hidráulicos
          </p>
        </div>
      </div>
    </footer>
  );
}